import { NotificationMessage } from "../models/models";
import { SerializedError } from "../models/errorHandlingModels";

export const serializeError = (error: any): SerializedError => {
  const serverMessage = error.response?.data?.message;
  return {
    message: serverMessage || error.message || "An error occurred",
    status: error.response?.status || 500,
    code: error.code || "UNKNOWN_ERROR",
    data: error.response?.data || null,
  };
};

export const createErrorNotification = (serializedError: SerializedError): NotificationMessage => {
  const errorObject = {
    message: serializedError?.message || "An error occurred",
    response: {
      status: serializedError?.status || 500,
      data: serializedError?.data || null,
    },
  };
  return NotificationMessage.error(errorObject);
}; 